import axios from "axios";
import { Cookies } from "react-cookie";
import { proxy } from "../config";
const cookie = new Cookies();

export const getDeals = async (dealType) => {
    const token = await cookie.get("token");
    return await axios.get(`${proxy}/deal/data/${dealType}`, {
        headers: { Authorization: token }
    });
};

export const getDeal = async (id) => {
    const token = await cookie.get("token");
    return await axios.get(`${proxy}/deal/deal/${id}`, {
        headers: { Authorization: token }
    });
};

export const updateStatusDeal = async (id, date, is_reject) => {
    const token = await cookie.get("token");
    return await axios.put(`${proxy}/deal/update/${id}`, {
        date: date,
        is_reject: is_reject
    }, {
        headers: { Authorization: token }
    });
};

export const hideDeal = async (id, formDate) => {
    const token = await cookie.get("token");
    return await axios.put(`${proxy}/deal/hide/${id}`, formDate, {
        headers: { Authorization: token }
    });
};